export const SITE = {
    name: "Flammingo Luxurious Spa",
    phoneDisplay: "+91 70399 34907",
    phoneHref: "tel:+917039934907",
    phone2Display: "+91 99209 22042",
    phone2Href: "tel:+919920922042",
    email: "flammingoluxuriousspa@gmail.com",
    emailHref: "mailto:flammingoluxuriousspa@gmail.com",
    location: "Vashi, Navi Mumbai",
    fullLocation: "Vashi, Navi Mumbai, Maharashtra, India",
    addressLine1: "2nd Floor, Palm Beach Galleria Mall",
    addressLine2: "211 / 212A / 212B / 213 / 214, Phase 2, Sector 19D",
    addressLine3: "Vashi, Navi Mumbai, Maharashtra 400703",
    hours: "11:00 AM \u2013 9:30 PM",
    days: "Open all 7 days",
    directionsUrl:
        "https://www.google.com/maps/dir/?api=1&destination=Palm+Beach+Galleria+Mall,+Sector+19D,+Vashi,+Navi+Mumbai,+Maharashtra+400703",
};

export const waLink = (message) =>
    `https://wa.me/917039934907?text=${encodeURIComponent(message)}`;

export const WA_BOOK = waLink(
    "Hello Flammingo Luxurious Spa, I would like to book an experience."
);

export const scrollToId = (selector) => {
    const el = document.querySelector(selector);
    if (!el) return;
    if (window.__lenis) {
        window.__lenis.scrollTo(el, { offset: -72, duration: 1.4 });
    } else {
        el.scrollIntoView({ behavior: "smooth" });
    }
};

export const NAV_LINKS = [
    { label: "Home", href: "#home" },
    { label: "About Us", href: "#about" },
    { label: "Services", href: "#services" },
    { label: "Experience", href: "#experience" },
    { label: "Contact", href: "#contact" },
];

export const SERVICES = [
    {
        slug: "aroma-therapy",
        name: "Aroma Therapy",
        image: "/images/aroma.jpg",
        alt: "Aroma therapy ritual at Flammingo Luxurious Spa, a luxury spa in Vashi",
        description:
            "Calming aromas, a soothing touch and a deeply relaxing atmosphere — an unhurried ritual designed to quiet the senses.",
    },
    {
        slug: "swedish-therapy",
        name: "Swedish Therapy",
        image: "/images/swedish.jpg",
        alt: "Swedish therapy at Flammingo Luxurious Spa, massage spa in Vashi",
        description:
            "Gentle-to-moderate techniques in a serene setting, leaving you relaxed, refreshed and quietly restored.",
    },
    {
        slug: "balinese-massage",
        name: "Balinese Massage",
        image: "/images/balinese.jpg",
        alt: "Balinese massage experience at Flammingo Luxurious Spa, Navi Mumbai",
        description:
            "An exotic-inspired wellness experience that pairs relaxing massage techniques with a truly tranquil atmosphere.",
    },
    {
        slug: "thai-dry-massage",
        name: "Thai Dry Massage",
        image: "/images/thai-dry.jpg",
        alt: "Thai dry massage at Flammingo Luxurious Spa, spa in Vashi Navi Mumbai",
        description:
            "A traditional oil-free ritual of rhythmic pressure and gentle stretches, leaving you feeling light, loose and wonderfully at ease.",
    },
    {
        slug: "deep-tissue-massage",
        name: "Deep Tissue Massage",
        image: "/images/deep-tissue.jpg",
        alt: "Deep tissue massage at Flammingo Luxurious Spa, best spa in Vashi",
        description:
            "A firmer, more focused ritual of slow, deliberate strokes — designed for those who carry the weight of the week on their shoulders.",
    },
    {
        slug: "jacuzzi",
        name: "Jacuzzi",
        image: "/images/jacuzzi.jpg",
        alt: "Private luxury jacuzzi at Flammingo Luxurious Spa, Vashi Navi Mumbai",
        description:
            "Warm water relaxation in a luxurious private setting — your own quiet moment of indulgence.",
    },
    {
        slug: "hammam-bath",
        name: "Hammam Bath",
        image: "/images/hammam.jpg",
        alt: "Moroccan-inspired hammam bath ritual at Flammingo Luxurious Spa, luxurious spa in Navi Mumbai",
        description:
            "A traditional-inspired bathing and relaxation ritual, reimagined in a warm, luxurious setting.",
    },
];
